import React, { useState } from 'react';
import {
  ThemeProvider,
  createTheme,
  Box,
  Typography,
} from '@mui/material';
import dayjs from 'dayjs';
import Login from './components/Login';
import StorySection from './sections/StorySection';
import TimerSection from './sections/TimerSection';
import LetterSection from './sections/LetterSection';
import { LandingSection } from './sections/LandingSection';
import SequentialScrollView from './components/SequentialScrollView';
import { AnimatePresence, motion } from "framer-motion";
import { EndingSection } from './sections/EndingSection';
import { StickyContainer } from './components/StickyContainer';
import { EmojiBackground } from './components/EmojiBackground';

// Create a pink/white theme
const theme = createTheme({
  palette: {
    primary: { main: '#F4CCE9' },
    secondary: { main: '#FF748B' },
    background: { default: '#fff' },
  },
  // Add a global font style
  typography: {
    fontFamily: "Mali, serif",
  },
});

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isPlayed, setIsPlayed] = useState(false);
  const meetingDate = dayjs('2022-12-01');

  return (
    <ThemeProvider theme={theme}>
      <LandingSection onPlay={() => setIsPlayed(true)} />

      {isPlayed && isLoggedIn && <EmojiBackground />}

      {isPlayed && (
        // <Box sx={{
        //   backgroundColor: '#FFE6F9',
        //   height: '100dvh', // enables smooth scrolling
        //   overflowY: 'auto',
        //   overflowX: 'hidden',
        //   scrollSnapType: 'y mandatory',
        //   scrollBehavior: 'smooth', // enables smooth scrolling
        // }}>
        <StickyContainer
          scrollMaping={[0.2, 0.51, 0.61, 0.76]}
          bgColorMaping={["#FFE6F9", "#FFE6F9", "#F7D5FA", "#E7E8FF"]}
        >
          <AnimatePresence mode="wait"> {/* not working */}
            {!isLoggedIn && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
              >
                <SequentialScrollView
                  components={[
                    <Typography variant="h4">ตอนนี้ เค้าอยากให้บี๋ใส่รหัส 6 หลัก🔒</Typography>,
                    <Typography variant="h4">รหัสคือ <strong>วันแรกที่</strong> เราคบกัน 💖</Typography>,
                    <Login onLogin={() => setIsLoggedIn(true)} title="ใส่รหัสก่อนน้า 💕 (DD MM YY)" />,
                  ]}
                  durations={[2000, 3000, 3000]}
                />
              </motion.div>
            )}

            {isLoggedIn && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
              >
                <LetterSection />

                <TimerSection meetingDate={meetingDate} />

                <StorySection />

                <EndingSection />
              </motion.div>
            )}
          </AnimatePresence>
          {/* </Box> */}
        </StickyContainer>
      )}
    </ThemeProvider >
  );
}

export default App;
